module.exports = __webpack_public_path__ + "static/our-process-cf411a2915a63afa839dbf87881631e6.jpg";